import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then(registrations => {
        registrations
          .filter(registration => [registration.active, registration.waiting, registration.installing]
            .some(worker => worker?.scriptURL?.includes('/service-worker.js')))
          .forEach(registration => registration.unregister());
      })
      .catch(() => {});
  });
}
